import Enum from 'enum';

const HttpCode = new Enum({ 'OK': 200 });

export default HttpCode;



// WEBPACK FOOTER //
// ./src/views/Framework/Constants/HttpCode.tsx